<template>
  <div>
    <van-dialog
      :value="value"
      @input="closeApp"
      title="提示"
      class="my-dialog"
      :showConfirmButton="false"
    >
      <img
        class="close"
        src="@/assets/images/icon/close1.png"
        alt=""
        @click="closeApp"
      />
      <div class="box">
        <img
          v-if="showbutton"
          src="@/assets/images/icon/close.png"
          alt=""
          @click="closeApp"
        />
        <p>打开稚旅APP，观看更多内容</p>
        <!-- 权限不够,伪按钮标签 -->
        <button class="fake-btn" @click="download()">
          立即打开
        </button>
      </div>
    </van-dialog>
    <button
      class="fake-btn"
      v-if="!isPassWeixin && value"
      @click="handleNotSatisfied"
    >
      立即打开
    </button>
    <!-- 注意：
      1.wx-open-launch标签要求微信版本至少7.0.12才能拉起
      2.微信开发工具不能拉起APP
      3.wx-open-launch标签要在正式域名下，才能显示标签里面的内容
      4.当前开发工具的版本：1.05.2103200,关联的微信版本是7.0.4 -->
    <wx-open-launch-app
      v-else
      id="launch-btn"
      @error="handleError"
      @launch="handleLaunch"
      :extinfo="extData"
      appid="wxddedce63f477f41e"
    >
      <script type="text/wxtag-template">
        <style>
          .wx-open-tag-download {
            border: 1px solid #43C18F;
            background: #43C18F;
            font-weight: 600;
            color: #fff;
            outline: none;

            font-size: 13px;
            border-radius: 30px;
            padding: 8px 14px;
          }
        </style>
        <button class="wx-open-tag-download">立即打开</button>
      </script>
    </wx-open-launch-app>
    <share-tip
      :show="showTip"
      @close="showTip = false"
      text="点击右上角，选择在浏览器打开"
    />
  </div>
</template>

<script>
import Env from '@/config/env'
import Home from '@/models/home'
import shareTip from '@/components/shareTip/shareTip'
export default {
  components: {
    shareTip
  },
  props: {
    value: Boolean, //拉起APP组件是否显示
    extData: String, //跳转App信息
    // 显示关闭按钮
    showbutton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDialog: this.value, //打开APP弹框
      showTip: false, //提示弹框
      isPassWeixin: false, //微信版本是否达标
      isPassIOS: false, //苹果系统是否达标
      isPassAndroid: false //安卓系统是否达标
    }
  },
  created() {
    this.judgeWeixinVersion()
  },
  methods: {
    closeApp() {
      this.$emit('input')
    },
    //处理条件不满足
    handleNotSatisfied() {
      if (!this.isPassWeixin) {
        this.$dialog
          .alert({
            title: '提示',
            message: '请升级微信'
          })
          .then(() => {
            this.closeApp()
          })
      }
    },
    init() {
      this.judgeWeixinVersion()
    },
    //判断微信版本是否达到最低要求 7.0.12
    judgeWeixinVersion() {
      /* eslint-disable */
      const wechatInfo = window.navigator.userAgent.match(
        /MicroMessenger\/([\d\.]+)/i
      )
      /* eslint-disable */
      if (!wechatInfo) return false
      const versionStr = wechatInfo[1]
      const result = this.versionStringCompare(versionStr, '7.0.12')
      if (result >= 0) {
        this.isPassWeixin = true
      }
    },
    //判断安卓系统版本是否达到最低要求 5.0
    judgeAndroidVersion() {
      const androidInfo = window.navigator.userAgent.match(
        /; Android ([\d\.]+);/i
      )
      const versionStr = androidInfo[1]
      const result = this.versionStringCompare(versionStr, '5.0')
      if (result >= 0) {
        this.isPassAndroid = true
      }
    },
    //判断苹果系统系统版本是否达到最低要求 10.3
    judgeIOSVersion() {
      // const iosInfo = window.navigator.userAgent.match(/cpu iphone os (\d+)\_(\d+) like/i)
      const iosInfo = window.navigator.userAgent.match(
        /CPU iPhone OS ([\d\_]+) like/i
      )
      const versionStr = iosInfo[1].split('_').join('.')
      const result = this.versionStringCompare(versionStr, '10.3')
      if (result >= 0) {
        this.isPassIOS = true
      }
    },
    /***
     * @param {string} preVersion  //版本1
     * @param {string} lastVersion  //版本2
     * @return {number} 1:版本1>版本2  0:版本1==版本2 -1:版本1<版本2
     */
    versionStringCompare(preVersion, lastVersion) {
      let sources = preVersion.split('.')
      let dests = lastVersion.split('.')
      let maxL = Math.max(sources.length, dests.length)
      let result = 0
      for (let i = 0; i < maxL; i++) {
        let preValue = sources.length > i ? sources[i] : 0
        let preNum = isNaN(Number(preValue))
          ? preValue.charCodeAt()
          : Number(preValue)
        let lastValue = dests.length > i ? dests[i] : 0
        let lastNum = isNaN(Number(lastValue))
          ? lastValue.charCodeAt()
          : Number(lastValue)
        if (preNum < lastNum) {
          result = -1
          break
        } else if (preNum > lastNum) {
          result = 1
          break
        }
      }
      return result
    },
    handleLaunch() {
      this.closeApp()
    },
    handleError(e) {
      console.log('error', e, e.detail)
      this.download()
      // dialog.alert({ message: "error:" + JSON.stringify(e.detail) });
    },
    download() {
      if (this.utils.isIOS()) {
        this.downloadIos()
      } else {
        this.downloadAndroid()
      }
    },
    async downloadAndroid() {
      if (Env.mobileUrlList.indexOf(window.location.hostname) !== -1) {
        window.location.href =
          'https://a.app.qq.com/o/simple.jsp?pkgname=com.yizhilu.zhuoyueparent'
      } else {
        if (this.utils.isWeiXin()) {
          this.showTip = true
          this.closeApp()
          return
        }
        const res = await Home.getUpdaterApp()
        window.location.href = res.data.url
      }
    },
    async downloadIos() {
      if (Env.mobileUrlList.indexOf(window.location.hostname) !== -1) {
        // 已替换ios连接
        window.location.href = 'https://apps.apple.com/cn/app/id6743700877'
      } else {
        if (this.utils.isWeiXin()) {
          this.showTip = true
          this.closeApp()
          return
        }
        window.location.href = 'https://fir.im/btmu'
      }
    },
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/global.less';
.fake-btn {
  border: 1px solid #43C18F;
  background: #fff;
  font-size: 28 / @r;
  font-weight: 600;
  border-radius: 16 / @r;
  padding: 12 / @r 22 / @r;
  color: #43C18F;
  outline: none;
}
.my-dialog {
  /deep/.van-dialog__content {
    text-align: center;
    padding-bottom: 32 / @r;
    position: relative;
    .close {
      position: absolute;
      top: -40%;
      right: 2%;
      width: 60 / @r;
      height: 60 / @r;
    }
    p {
      margin: 0;
      padding: 16 / @r 48 / @r 48 / @r;
    }
  }
}
.box{position: relative;height: 180 / @r;
  
  img{width: 28 / @r;height: 28 /@r;position: absolute;right: 30 / @r;top: -42 / @r;}
}
</style>
